import { getGapAnalysisDate } from '.';

export const getGapDateRangesFromPeriodSelection = (
    periodSelection: GapAnalysisPeriodSelection | null,
): GapDateRanges => {
    const detectionsEnd = getGapAnalysisDate(
        periodSelection?.detection_data_end ?? null,
        'end',
    );
    const detectionsStart = getGapAnalysisDate(
        periodSelection?.detection_data_start ?? null,
        'start',
    );
    const performancePeriodEnd = getGapAnalysisDate(
        periodSelection?.performance_period_end ?? null,
        'end',
    );
    const performancePeriodStart = getGapAnalysisDate(
        periodSelection?.performance_period_start ?? null,
        'start',
    );
    const statementPeriodEnd = getGapAnalysisDate(
        periodSelection?.pro_statement_period_label?.end_date ?? null,
        'end',
    );
    const statementPeriodStart = getGapAnalysisDate(
        periodSelection?.pro_statement_period_label?.start_date ?? null,
        'start',
    );

    return {
        detections: {
            end: detectionsEnd,
            start: detectionsStart,
        },
        performancePeriod: {
            end: performancePeriodEnd,
            start: performancePeriodStart,
        },
        statementPeriod: {
            end: statementPeriodEnd,
            start: statementPeriodStart,
        },
    };
};
